class ProductPreorder extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (!this.data) return

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.VARIANT_CHANGE,
      this.onVariantChange.bind(this),
    )
  }

  onVariantChange (e) {
    const variantId = e?.detail?.variant?.data?.id || false
    this.updatePreorderMessage(variantId)
  }

  updatePreorderMessage (variantId) {
    const variantIdString = variantId.toString()
    const variantData = this.data.find((item) => item.id === variantIdString)

    if (
      !variantData ||
      variantData.enable !== 'true' ||
      !variantData.messageTemplate ||
      !variantData.expectedShippingDate
    ) {
      this.setAttribute('aria-hidden', 'true')
      return
    } else {
      this.setAttribute('aria-hidden', 'false')
    }

    // Create a temporary DOM to decode the HTML entities that were escaped in the Liquid snippet
    const div = document.createElement('div')
    div.innerHTML = variantData.messageTemplate.replace(
      '[date]',
      variantData.expectedShippingDate,
    )
    const messageElement = div.textContent || div.innerText

    // Output the decoded HTML into a target element
    this.innerHTML = messageElement

    // Add attributes to the product form's custom properties input
    this.externalEls.input.elements.forEach((externalInputEl) => {
      externalInputEl.setAttribute('name', 'properties[Pre-order]')
      externalInputEl.setAttribute('value', variantData.expectedShippingDate)
    })
  }

  removePreorderStatus () {
    this.innerHTML = ''

    // Remove attributes to the product form's custom properties input
    this.externalEls.input.elements.forEach((externalInputEl) => {
      externalInputEl.setAttribute('name', '')
      externalInputEl.setAttribute('value', '')
    })
  }

  get data () {
    if (this.dataset.objectType === 'product') {
      return false
    }
    try {
      return JSON.parse(this.dataset.preorderData)
    } catch (error) {
      console.error('Error parsing pre-order data.')
      return false
    }
  }
}

if (!customElements.get('product-preorder')) {
  customElements.define('product-preorder', ProductPreorder)
}
